export const humanEvent = { detected: false };
export const events = ['mousedown', 'mouseup', 'mousemove', 'wheel', 'keydown', 'keyup', 'touchstart'];

export const isHuman = () => {
    humanEvent.detected = true;
    events.forEach(name => window.removeEventListener(name, isHuman, true));
};

export const startDetectHumanEvent = () => {
    events.forEach(name => window.addEventListener(name, isHuman, true));
};
